import { useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { AppConfig } from 'AppConfig';
import LocalStore from 'utils/LocalStore';

const FIVE_MINUTES = 5 * 60 * 1000;

const usePermissionsRefreshTimer = () => {
    const currentTenantCd = useSelector((state) => state.user.currentTenantCd);
    const timerRef = useRef(null);
    
    const refreshPermissions = useCallback(async () => {
        try {
            const token = LocalStore.getAccessToken();
            if (!token) return;
            
            await axios.post(`${AppConfig.FO_SEARCH_URL}/api/update-permissions`, {}, { hideSpinner: true });
            
            console.debug('Report permissions refreshed successfully');
        } catch (error) {
            console.error('Failed to refresh report permissions:', error);
        }
    }, []);
    
    const startTimer = useCallback(() => {
        if (timerRef.current) clearInterval(timerRef.current);
        
        //  Delay first API call by 5 minutes on timer start
        timerRef.current = setTimeout(() => {
            refreshPermissions();
            timerRef.current = setInterval(() => {
                refreshPermissions();
            }, FIVE_MINUTES);
        }, FIVE_MINUTES);
    }, [refreshPermissions]);
    
    const stopTimer = useCallback(() => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    }, []);
    
    useEffect(() => {
        if (currentTenantCd) {
            startTimer();
        }
        return () => stopTimer();
    }, [currentTenantCd, startTimer, stopTimer]);
};

export default usePermissionsRefreshTimer;
